import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Palette } from "../AppConfig";
import { saveJobBasic, deepCopy } from "../components/Common";

import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { changePage, MAIN_PAGE, SHOW_CUSTOMER_JOB_PANEL, toggleDesigner } from "../redux_store/appState";
import CreateIcon from "@material-ui/icons/Create";
import UndoIcon from "@material-ui/icons/Undo";
import RedoIcon from "@material-ui/icons/Redo";
import RefreshIcon from "@material-ui/icons/Refresh";
import WebIcon from "@material-ui/icons/Web";

import * as Paper from "./layout/PaperFunctions";

import { THREED_MODE, THREED_MINI_MODE, UNDO, REDO, TOOL_DRAWER_HIDE } from "../redux_store/appState";

import { updateLayout2D, updateLayout3D } from "../redux_store/appStateHelper";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        height: "86px",
        zIndex: "9998",
        backgroundColor: theme.brand.LYSAGHT ? Palette.Lysaght.LightGrey : "#F4F4F4",
        position: "absolute",
        borderBottom: "1px solid #acc2d1",
        paddingTop: "48px",
        display: "flex",
        position: "fixed",
        top: "0px",
        width: "100%",
        paddingRight: "0px !important",
    },
    icon: {
        paddingRight: "10px",
        width: "34px",
        height: "34px",
    },
    iconButton: {
        fontSize: theme.brand.FIELDERS ? "14px" : "14px",
        fontFamily: theme.typography.fontFamilySecondary,
        fontWeight: "400",
        color: theme.palette.primary.main,
        marginTop: "-4px",
        borderRadius: "0%",
        textTransform: theme.brand.FIELDERS ? "uppercase" : "capitalize",
    },
    iconButtonRoot: {
        padding: "4px 12px",
    },
    jobName: {
        fontSize: theme.brand.FIELDERS ? "20px" : "18px",
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.brand.FIELDERS ? "400" : "600",
        color: Palette.Control.DarkGrey,
        flex: "1",
        alignSelf: "center",
        cursor: "pointer",
        textTransform: theme.brand.FIELDERS ? "none" : "uppercase",
    },
    tools: {
        fontSize: "20px",
        fontFamily: theme.typography.fontFamily,
        fontWeight: "400",
        color: Palette.Control.DarkGrey,
        alignSelf: "center",
        paddingRight: "10px",
    },
    selected: {
        background: theme.brand.FIELDERS ? "#1a3061" : Palette.Lysaght.DarkBlue,
        color: "white",
    },
}));

export default function HeaderBar(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const job = useSelector((state) => state?.job);
    const app = useSelector((state) => state?.app);

    const HAS_UNDO = app?.job_history_buffer?.pointer > 0 && app?.job_history_buffer?.data?.length > 0;
    const HAS_REDO = app?.job_history_buffer?.pointer < app?.job_history_buffer?.data?.length - 1;
    const THREED_mode = app.designer[THREED_MODE];
    const threed_mini_mode = app.designer[THREED_MINI_MODE];
    const TOOL_DRAWER_HIDE_mode = app.designer[TOOL_DRAWER_HIDE];
    const SHOW_LOADING_BACKDROP = app.designer.SHOW_LOADING_BACKDROP;

    // const toggleProperties = () => {

    //   // if (app.designer[TOOL_DRAWER_OPEN]) dispatch(updateDesigner(TOOL_DRAWER_OPEN, false));
    //   else if (!app.designer[TOOL_DRAWER_HIDE]) dispatch(updateDesigner(TOOL_DRAWER_HIDE, true));
    //   else {
    //     dispatch(updateDesigner(TOOL_DRAWER_HIDE, false));
    //     dispatch(updateDesigner(TOOL_DRAWER_OPEN, true));
    //   }

    // }

    let job_title = <i>Untitled Job</i>;
    if (job?.Customer?.JobName) job_title = job?.Customer?.JobName + " (#" + job?.id + ")";

    return (
        <div className={classes.root}>
            <IconButton
                className={classes.iconButton}
                classes={{ root: classes.iconButtonRoot }}
                onClick={() => {
                    if (!job) return;
                    var save_job = deepCopy(job);

                    if (app?.user && save_job)
                        save_job.LastEditor = {
                            id: app.user.id,
                            DisplayName: app.user.DisplayName,
                            UserCode: app.user.UserCode,
                            _session_id: "",
                            _ts: Date.now(),
                        };

                    saveJobBasic(save_job, false);
                    window.svg = null;
                    window.svg_data = null;
                    window.job = null;
                    Paper.ClearAll();

                    dispatch(changePage(MAIN_PAGE));
                }}
            >
                <ChevronLeftIcon className={classes.icon} /> Back to Jobs
            </IconButton>
            <div
                className={classes.jobName}
                onClick={() => {
                    if (job && !SHOW_LOADING_BACKDROP) dispatch(toggleDesigner(SHOW_CUSTOMER_JOB_PANEL));
                }}
            >
                {job_title}
                <IconButton className={classes.iconButton} classes={{ root: classes.iconButtonRoot }}>
                    <CreateIcon className={classes.icon} /> Edit Details
                </IconButton>
            </div>
            <div className={classes.tools}>
                <IconButton
                    className={classes.iconButton}
                    classes={{ root: classes.iconButtonRoot }}
                    disabled={!HAS_UNDO}
                    onClick={() => (HAS_UNDO ? dispatch(UNDO()) : () => {})}
                >
                    <UndoIcon className={classes.icon} /> Undo
                </IconButton>
                <IconButton
                    className={classes.iconButton}
                    classes={{ root: classes.iconButtonRoot }}
                    disabled={!HAS_REDO}
                    onClick={() => (HAS_REDO ? dispatch(REDO()) : () => {})}
                >
                    <RedoIcon className={classes.icon} /> Redo
                </IconButton>
                <IconButton
                    className={classes.iconButton}
                    classes={{ root: classes.iconButtonRoot }}
                    onClick={() => {
                        if (job && !SHOW_LOADING_BACKDROP) {
                            if (THREED_mode) dispatch(updateLayout3D());
                            if (!THREED_mode || (THREED_mode && threed_mini_mode)) dispatch(updateLayout2D());
                        }
                    }}
                >
                    <RefreshIcon className={classes.icon} /> Refresh
                </IconButton>
                <IconButton
                    className={classes.iconButton + (TOOL_DRAWER_HIDE_mode ? "" : " " + classes.selected)}
                    classes={{ root: classes.iconButtonRoot }}
                    onClick={() => {
                        dispatch(toggleDesigner(TOOL_DRAWER_HIDE));
                    }}
                >
                    <WebIcon className={classes.icon} /> Properties
                </IconButton>
            </div>
        </div>
    );
}
